import React, { useState, useEffect } from "react";

function AddProject() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [no_of_interns, setNoOfInterns] = useState("");
  const [duration, setDuration] = useState("");
  const [mode, setMode] = useState("");
  const [prerequisites, setPrerequisites] = useState("NONE");
  const [departmentId, setDepartmentId] = useState("");
  const [departments, setDepartments] = useState([]);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Fetch departments on mount
  useEffect(() => {
    const fetchDepartments = async () => {
      setIsLoading(true);
      try {
        const res = await fetch("/api/professors/department_list", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });

        if (!res.ok) {
          const errorData = await res.json();
          throw new Error(
            errorData.detail?.message || "Failed to fetch departments"
          );
        }

        const data = await res.json();
        // Transform the data to match expected format
        const formattedDepartments = Array.isArray(data)
          ? data.map(dept => ({
              id: dept.user_id, // Using user_id as id since that's what your backend sends
              name: dept.name
            }))
          : [];
        setDepartments(formattedDepartments);
      } catch (error) {
        console.error("Error fetching departments:", error);
        setMessage(error.message || "Error loading departments");
      } finally {
        setIsLoading(false);
      }
    };
    fetchDepartments();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    // Validate form fields
    if (!title || !description || !no_of_interns || !duration || !mode || !departmentId) {
      setMessage("Please fill all required fields");
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch("/api/professors/projects", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
        body: JSON.stringify({
          title,
          description,
          no_of_interns: parseInt(no_of_interns),
          duration,
          mode,
          prerequisites,
          dept_id: departmentId,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        // Handle different error formats
        let errorMessage = "Failed to create project";
        if (Array.isArray(data.detail)) {
          errorMessage = data.detail.map(err => err.msg).join(", ");
        } else if (data.detail?.msg) {
          errorMessage = data.detail.msg;
        } else if (typeof data.detail === 'string') {
          errorMessage = data.detail;
        }
        throw new Error(errorMessage);
      }

      setMessage("Project created successfully!");
      // Reset form
      setTitle("");
      setDescription("");
      setNoOfInterns("");
      setDuration("");
      setMode("");
      setPrerequisites("NONE");
      setDepartmentId("");
    } catch (error) {
      console.error("Error creating project:", error);
      setMessage(error.message || "An error occurred while creating the project");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="add-project-form">
      <h2>Add Project</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Title*</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label>Description*</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label>Number of Interns*</label>
          <input
            type="number"
            value={no_of_interns}
            onChange={(e) => setNoOfInterns(e.target.value)}
            min="1"
            required
          />
        </div>

        <div className="form-group">
          <label>Duration*</label>
          <select
            value={duration}
            onChange={(e) => setDuration(e.target.value)}
            required
          >
            <option value="">Select Duration</option>
            <option key="duration-1" value="1 month">1 month</option>
            <option key="duration-2" value="2 months">2 months</option>
            {/* <option key="duration-3" value="3 Months">3 Months</option> */}
            {/* <option key="duration-6" value="6 Months">6 Months</option> */}
          </select>
        </div>

        <div className="form-group">
          <label>Mode*</label>
          <select
            value={mode}
            onChange={(e) => setMode(e.target.value)}
            required
          >
            <option value="">Select Mode</option>
            <option key="mode-online" value="ONLINE">Online</option>
            <option key="mode-offline" value="OFFLINE">Offline</option>
            <option key="mode-hybrid" value="HYBRID">Hybrid</option>
          </select>
        </div>

        <div className="form-group">
          <label>Prerequisites</label>
          <input
            type="text"
            value={prerequisites}
            onChange={(e) => setPrerequisites(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Department*</label>
          <select
            value={departmentId}
            onChange={(e) => setDepartmentId(e.target.value)}
            required
            disabled={isLoading || departments.length === 0}
          >
            <option value="">Select Department</option>
            {departments.map((dept) => (
              <option key={`dept-${dept.id}`} value={dept.id}>
                {dept.name}
              </option>
            ))}
          </select>
          {isLoading && <p>Loading departments...</p>}
          {!isLoading && departments.length === 0 && (
            <p>No departments available</p>
          )}
        </div>

        <button 
          type="submit" 
          className="submit-button"
          disabled={isLoading}
        >
          {isLoading ? "Submitting..." : "Add Project"}
        </button>
      </form>

      {message && (
        <p style={{
          marginTop: "10px",
          color: message.includes("success") ? "green" : "red"
        }}>
          {message}
        </p>
      )}
    </div>
  );
}

export default AddProject;